import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const viewHeaderTitleCss = css`
  font-size: 18px;
  font-weight: 600;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  height: 52px;
  line-height: 52px;
  letter-spacing: 0.3px;
  white-space: nowrap;
`;
